import {useEffect, useState} from "react";
import {getBooking} from "../api/apiClient";

export const useBooking = (bookingUuid) => {
    const [booking, setBooking] = useState([]);

    useEffect(() => {
        const abortController = new AbortController();
        const booking = getBooking(bookingUuid, abortController.signal);

        booking
            .then(
                (data) => {
                    const booking = data;

                    setBooking(booking)
                }
            )
            .catch(
                (error) => console.log(error)
            );

        return () => {
            abortController.abort();
        };
    }, [bookingUuid]);

    return {booking : booking};
};